<template>
	<v-header title="体检套餐" headerLeftStatus="true" />
	<div class="sysMain">
		<div v-if="view.show">
			<img :src="require('../../static/wwwroot/suite/'+model.suite.imgUrl)" style="width: 100%;" />
			<div>
				<Card>
					<Row>
						<Col style="font-size:0.5rem ;">
						<Text type="danger">
							<Numeral :value="model.suite.amount" format="0,0.00">
								<template #prefix>
									<strong>¥ </strong>
								</template>
							</Numeral>
						</Text>
						<label v-show="model.suite.amount != model.suite.orgAmount" style="text-decoration: line-through;padding-left:10px;">{{model.suite.orgAmount}}</label>
						</Col>
					</Row>
					<Row>
						<Col style="font-size:0.35rem ;">
						<b>{{model.suite.suiteName}}</b>
						</Col>
					</Row>
					<Row>
						<Col style="color: #999999;">
						{{model.suite.synopsis}}
						</Col>
					</Row>
				</Card>
				<Card style="margin:10px 10px 0px 10px;">
					<Row>
						<Col>
						<Icon type="md-radio-button-on" style="color: #2A99FF; font-size: 20px;" />
						</Col>
						<Col flex="auto" style=" max-width: calc(100% - 20px);padding-left: 5px; ">
						<Row style="padding-bottom: 10px;">
							<Col>
							<b style="font-size: 15px;">套餐特点</b>
							</Col>
						</Row>
						<Row>
							<Col>
							{{model.suite.characteristic}}
							</Col>
						</Row>
						</Col>
					</Row>
				</Card>
				<Card style="margin:10px 10px 0px 10px;">
					<Row>
						<Col>
						<Icon type="md-radio-button-on" style="color: #2A99FF; font-size: 20px;" />
						</Col>
						<Col flex="auto" style=" max-width: calc(100% - 20px);padding-left: 5px; ">
						<Row style="padding-bottom: 10px;">
							<Col>
							<b style="font-size: 15px;">适用人群</b>
							</Col>
						</Row>
						<Row>
							<Col>
							<Space wrap :size="[30, 10]">
								<template v-for=" crowd in model.suite.crowd">
									<img :src="require('../../static/wwwroot/suite/'+crowd.url)"
										style="width: 75px;height: 75px;" />
									<div style="text-align: center;padding-top: 10px;">
										<span>{{crowd.name}}</span>
									</div>
								</template>
							</Space>
							</Col>
						</Row>
						</Col>
					</Row>
				</Card>
				<Card style="margin:10px 10px 0px 10px;">
					<Row>
						<Col>
						<Icon type="md-radio-button-on" style="color: #2A99FF; font-size: 20px;" />
						</Col>
						<Col flex="auto" style=" max-width: calc(100% - 20px); ">
						<Row style="padding-bottom: 10px;">
							<Col>
							<b style="font-size: 15px;">疾病筛查</b>
							</Col>
						</Row>
						</Col>
					</Row>
					<Grid :col="3" :border="false" padding="0px">
						<GridItem v-for=" diseaseScreen in model.suite.diseaseScreen" style="text-align: center;">
							<div style="align-items: center;"><img
									:src="require('../../static/wwwroot/suite/'+diseaseScreen.url)"
									style="width: 45px;height: 45px;" /></div>
							<div style="padding-top: 10px; ">
								{{diseaseScreen.name}}
							</div>
						</GridItem>
					</Grid>
				</Card>
				<Card style="margin:10px 10px 50px 10px;" :shadow="true">
					<Row>
						<Col>
						<Icon type="md-radio-button-on" style="color: #2A99FF; font-size: 20px;" />
						</Col>
						<Col flex="auto" style=" max-width: calc(100% - 20px);padding-left: 5px; ">
						<Row style="padding-bottom: 10px;">
							<Col>
							<b style="font-size: 15px;">套餐项目({{model.examFeeItemCount}})</b>
							</Col>
						</Row>
						</Col>
					</Row>
					<div v-for=" depart in model.itemList ">
						<div
							style=" border-bottom: 1px dashed #E8EAEC; margin-bottom:5px; padding-bottom: 5px; padding-left: 10px; ">
							<Icon type="ios-bookmark" color="#2A99FF" size="15" />{{depart.departName}}
							<!-- ({{depart.examFeeItemList.length}})项 -->
						</div>
						<div v-for=" examFee in depart.examFeeItemList "
							style="line-height: 30px;padding-bottom: 10px;">
							<div style="padding-left: 10px;">
								{{examFee.examFeeItemName}}
							</div>
							<div
								style="background-color: #F3F4F6; line-height: 30px;padding-left: 10px; border-radius: 6px; ">
								{{examFee.examFeeItemDesc}}
							</div>
						</div>
					</div>
				</Card>
			</div>
			<div v-show="view.disabledPay===false"
				style="position: fixed;left: 0;bottom: 0;height: 40px; background-color: white;width: 100%; ">
				<Row justify="center" align="middle">
					<Col flex="auto" style="padding-left: 20px;font-size:0.5rem ; ">
					<Text type="danger" style="padding-right: 10px;">
						<Numeral :value="model.suite.amount" format="0,0.00">
							<template #prefix>
								<strong>¥ </strong>
							</template>
						</Numeral>
					</Text></Col>
					<Col flex="70px" style="padding-right: 5px;"><Button type="primary" @click="cart()">加入购物车</Button>
					</Col>
				</Row>
			</div>
		</div>
	</div>
</template>

<script>
	import header from "@/components/header/index";
	import footer from "@/components/footer/index";
	import {
		sysPost
	} from '@/utils/api'
	import {
		getToken,
	} from '@/utils/auth'
	export default {
		name: 'contactus',
		data() {
			return {
				view: {
					disabledPay: false,
					show: false
				},
				model: {}
			};
		},
		created() {
			var token = getToken();
			if (token) this.view.disabledPay = token.viewDisabledPay;
			this.init();
		},
		methods: {
			init() {
				var that = this;
				var id = this.$route.query.id;
				sysPost(that, {
					"url": 'Suite/Detail',
					"data": {
						Id: id
					}
				}, function(result) {
					that.view.show = true;
					that.model = result;
					if (!that.isNullOrEmptyEx(that.model.suite.crowd)) that.model.suite.crowd = JSON.parse(that
						.model.suite.crowd);
					if (!that.isNullOrEmptyEx(that.model.suite.diseaseScreen)) that.model.suite.diseaseScreen =
						JSON.parse(that.model.suite.diseaseScreen);
				})
			},
			cart() {
				var that = this;
				this.addCart({
					suiteId: that.model.suite.suiteId, //套餐Id
					suiteName: that.model.suite.suiteName, //套餐名称
					describe: "项目数:" + that.model.examFeeItemCount + "项", //描述
					unitPrice: that.model.suite.amount, //单价
					quantity: 1, //数量
				});
				this.$router.push("/mycart");
			}
		},
		components: {
			"v-header": header,
			"v-footer": footer
		}
	}
</script>

<style lang="less" scoped>
	.parts {
		position: absolute;
		background-color: whitesmoke;
		width: 100%;
		height: 100%;
		top: 0;
		bottom: 0;
		z-index: 999;
	}

	.partsHeader {
		width: 100%;
		z-index: 1;
		height: 1.3rem;
		line-height: 1.3rem;
		font-size: 12px;
		//background: white;
		position: fixed;
		-webkit-box-shadow: 0 0 10px #cecece;
		box-shadow: 0 0 10px #cecece;
		text-align: center;
		font-size: 0.41rem;
	}

	.partsHeader i {
		display: block;
		float: left;
		height: 50px;
		padding-left: 0.3rem;
		font-size: 0.71rem;
		color: black;
	}

	.partsMain {
		overflow-y: auto;
		height: calc(100% - 1.05rem);
	}

	.smallfont {
		font-size: 12px;
	}

	.suiteMain {
		margin: 5px;
		font-size: 12px;
	}

	/deep/ .ivu-list-item-meta-title {
		font-size: 13px;
		margin-bottom: 0px;
		font-weight: bold;
	}

	/deep/ .ivu-list-item-meta-description {
		font-size: 12px;
	}

	/deep/ .ivu-list-item-meta-avatar {
		margin-right: 5px;
	}
</style>
